import { render, staticRenderFns } from "./rewardChooseOneEdit_bak.vue?vue&type=template&id=530ac6a9&scoped=true&"
import script from "./rewardChooseOneEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardChooseOneEdit_bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ac6a9",
  null
  
)

export default component.exports